import { useState } from 'react';
import { FaGithub, FaLinkedin, FaHeart } from 'react-icons/fa';
import { IoMdMail } from 'react-icons/io';

export default function Footer() {
  const year = new Date().getFullYear();
  const [copied, setCopied] = useState(false);

  const handleEmailClick = (e) => {
    navigator.clipboard.writeText('atchayakannan03@gmail.com');
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <footer
      className="relative py-10 border-t"
      style={{ borderColor: 'rgba(255,255,255,0.06)', background: 'rgba(0,0,0,0.3)' }}
    >
      <div className="max-w-6xl mx-auto px-6">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6">
          {/* Logo */}
          <a href="#hero" className="text-lg font-bold gradient-text font-mono">
            &lt;Atchaya /&gt;
          </a>

          {/* Nav */}
          <nav className="flex flex-wrap justify-center gap-6 text-sm text-slate-500">
            {['About', 'Skills', 'Experience', 'Projects', 'Contact'].map(item => (
              <a
                key={item}
                href={`#${item.toLowerCase()}`}
                className="hover:text-violet-400 transition-colors"
              >
                {item}
              </a>
            ))}
          </nav>

          {/* Socials */}
          <div className="flex gap-3">
            {[
              { icon: <FaGithub size={16} />,   href: 'https://github.com/atchu33',                            label: 'GitHub' },
              { icon: <FaLinkedin size={16} />, href: 'https://www.linkedin.com/in/atchaya-k-713424211/', label: 'LinkedIn' },
              { icon: <IoMdMail size={16} />,   href: 'mailto:atchayakannan03@gmail.com',                      label: 'Email', isEmail: true },
            ].map(s => (
              <a
                key={s.label}
                href={s.href}
                aria-label={s.label}
                target={s.href.startsWith('http') ? '_blank' : undefined}
                rel="noreferrer"
                onClick={s.isEmail ? handleEmailClick : undefined}
                className="w-8 h-8 rounded-lg flex items-center justify-center text-slate-500 hover:text-violet-400 transition-all hover:-translate-y-0.5"
                style={{ background: 'rgba(255,255,255,0.05)', border: '1px solid rgba(255,255,255,0.08)' }}
              >
                {s.icon}
              </a>
            ))}
          </div>
        </div>

        <div className="mt-8 pt-6 text-center text-xs text-slate-600 border-t" style={{ borderColor: 'rgba(255,255,255,0.05)' }}>
          <p className="flex items-center justify-center gap-1">
            © {year} Atchaya Kannan. Built with <FaHeart className="text-violet-500" size={10} /> using React & Tailwind CSS
          </p>
        </div>
      </div>
      {copied && (
        <div className="fixed bottom-5 right-5 bg-slate-900/90 text-violet-400 border border-violet-500/30 px-4 py-2.5 rounded-xl shadow-xl backdrop-blur-sm text-sm font-semibold z-50 flex items-center gap-2" style={{ animation: 'bounce 1s infinite' }}>
          <span>📧 Email copied to clipboard!</span>
        </div>
      )}
    </footer>
  );
}
